import Vue from 'vue';
import Vuetify from 'vuetify';

import 'vuetify/dist/vuetify.min.css';

import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify, {
  iconfont: 'md'
});

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        primary: colors.purple.darken3,
        secondary: colors.purple.darken1,

        appBarBg: colors.purple.darken3,
        appBarTx: colors.deepPurple.lighten4,

        appDrawerBg: colors.purple.darken3,
        appDrawerTx: colors.deepPurple.lighten4,

        cardBg: '#fff',
        cardTx: '#303030',
        
      },
      dark: {
        primary: colors.grey.darken4,
        secondary: colors.grey.darken1,

        appBarBg: colors.black,
        appBarTx: colors.white,

        appDrawerBg: colors.grey.darken3,
        appDrawerTx: colors.grey.lighten4,

        cardBg: '#303030',
        cardTx: '#fff',
      },
    },
  },
});
